import { render, staticRenderFns } from "./activitySemestersManagment.html?vue&type=template&id=a176ce54&scoped=true&external"
import script from "./activitySemestersManagment.vue?vue&type=script&lang=js"
export * from "./activitySemestersManagment.vue?vue&type=script&lang=js"
import style0 from "./activitySemestersManagment.css?vue&type=style&index=0&id=a176ce54&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a176ce54",
  null
  
)

export default component.exports